import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE } from '../actions';

const initialState = {};

const subCompanyCreditProviderReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.GET_CREDIT_PROVIDER:
      case SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.UPDATE_CREDIT_PROVIDER:
        draft[meta.subCompanyId] = payload ?? null;
        break;

      case SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.DELETE_CREDIT_PROVIDER:
        delete draft[meta.subCompanyId];
        break;

      case SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyCreditProviderReducer;
